"use client";

import Script from "next/script";

import { initAnalytics } from "@/app/utilities/analytics";
import { readAnalyticsPageConfig } from "@/app/utilities/analytics/page-config";

export interface AnalyticsManagerProps {
	src: string;
}

/**
 * Analytics Manager initializer
 */
export function AnalyticsManager({ src }: AnalyticsManagerProps): JSX.Element {
	return (
		<Script
			src={src}
			onLoad={() => initAnalytics(readAnalyticsPageConfig())}
		/>
	);
}
